<template>
  <div>
    <div style="padding-bottom:0.35rem;">
      <span class="us_block_title">无线设备</span>
      <div>
        <!-- <v-btn style="width:30%;height:2.75rem;margin-right: 5%;" @click="goApDevice">无线设备</v-btn>
        <v-btn style="width:30%;height:2.75rem;margin-right: 5%;" @click="goApLog">无线设备日志</v-btn>
        <v-btn style="width:30%;height:2.75rem;" @click="goApGplot">无线设备关系图</v-btn> -->

        <v-row>
          <v-col :cols="4">
            <v-btn
              class=""
              color="info"
              style="margin-bottom: 0;"
              @click="goApDevice"
            >
              设备列表
              <v-icon light>mdi-state-machine</v-icon>
            </v-btn>
          </v-col>
          <v-col :cols="4">
            <v-btn
              class=""
              color="info"
              style="margin-bottom: 0;"
              @click="goApLog"
            >
              设备日志
              <v-icon light>mdi-receipt</v-icon>
            </v-btn>
          </v-col>
          <v-col :cols="4">
            <v-btn
              class=""
              color="info"
              style="margin-bottom: 0;"
              @click="goApGplot"
            >
              拓扑图
              <v-icon light>mdi-graph</v-icon>
            </v-btn>
          </v-col>
        </v-row>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: { },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '250px'
    }
  },
  data() {
    return {
      loading: true
    }
  },
  watch: {
  },
  activated() {

  },
  deactivated() {

  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    goApDevice() {
      this.$router.goPage('/ApDeviceList')
    },
    goApLog() {
      this.$router.goPage(`/ApLogList?prod_key=yqzn14dcomgF1Am7TX9s&dev_name=5BD6F61C-86FF-4511-95D6-DCAE96CC7BF4`)
    },
    goApGplot() {
      this.$router.goPage('/ApGplot')
    }
  }
}
</script>
<style scoped>
.us_block_title{
  font-weight:bold;
  font-size:1.05rem;
  color: rgba(33,33,33,0.9);
}
</style>
